import React, { Component } from "react";
import "./Cards.scss";
import { __Areas__, __CurrentAreas__, __AreasLabel__ } from "../Helpers/ArrayGrouping";
import { GA_Push } from "../Services/GoogleAnalytics";
import { mobile } from "../Services/Agent";
import Slider from "../Helpers/Slider/Slider";
import { InnerCard } from "../Helpers/CardHelper";

var timeout;

export default class Cards extends Component {
    constructor(props) {
        super();
        this.renderCards = this.renderCards.bind(this);
        this.setLocation = this.setLocation.bind(this);
        this.setOwlRef = this.setOwlRef.bind(this);
        this.state = {
            renderCards: [],
            currentLocation: 0
        }
    }
    // shouldComponentUpdate(props) {
    //     console.log(props);
    //     if (props.area != this.state.currentLocation) return true;
    //     return false;
    // }
    componentDidMount() {
        this.setLocation(this.props);
    }
    componentWillReceiveProps(nP) {
        this.setLocation(nP);
    }
    componentWillUpdate(props) {
        if (this.state.currentLocation != 0 &&
            props.area > 0 && props.area != this.state.currentLocation) {
            timeout ? window.clearTimeout(timeout) : null;
            this.cardsBlcok.classList.add("abouttochange");
            this.cardsBlcok.classList.remove("didchange");
        }
    }
    componentDidUpdate(props) {
        if (this.state.currentLocation != 0 && props.area == this.state.currentLocation) {
            timeout ? window.clearTimeout(timeout) : null;
            timeout = window.setTimeout(() => {
                this.cardsBlcok.classList.add("didchange");
                this.cardsBlcok.classList.remove("abouttochange");
            }, mobile() ? 800 : 1000);
        }
    }
    setLocation(props) {
        this.setState({
            currentLocation: props.area
        }, () => this.renderCards())
    }
    clickCard(card) {
        ((callback) => {
            GA_Push("Read_More_Clicked", card.Title);
            window.setTimeout(callback, 50);
        })(window.open(card.Link, "_blank"));
    }
    setOwlRef(ref) {
        if (!ref) return;
        this.setState({
            OwlRef: ref
        })
    }
    renderCards() {
        if (this.state.currentLocation == 0) return;
        let cards = [];

        __CurrentAreas__(this.state.currentLocation).map((card, index) =>
            cards.push(
                <InnerCard key={index} index={index}
                    {...card}
                    onClick={this.clickCard}
                />));
        this.setState({
            renderCards: cards
        })
    }
    render() {
        return (
            <section className="section section-cards didchange" ref={cardsBlcok => this.cardsBlcok = cardsBlcok}>
                <div className="content-container">
                    <div className="head">
                        <h2>
                            {__AreasLabel__(this.props.area)}
                        </h2>
                    </div>
                    <div className="cards">
                        <div className="slider">
                            {this.state.renderCards.length > 0 ?
                                <Slider
                                    currentLocation={this.props.area}
                                    setOwlRef={this.setOwlRef}>
                                    {this.state.renderCards}
                                </Slider> : ""}
                        </div>
                        <div className="mobilecards">
                            {this.state.renderCards}
                        </div>
                    </div>
                    <div className="backtomap" onClick={() => {
                        this.cardsBlcok.scrollTop = 0;
                        this.props.resetState();
                    }}>
                        <div className="icon"></div>
                        <div className="label">חזרה למפה</div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Cards/Cards.jsx